var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_date_filter"},[_c('div',{staticClass:"datepicker-trigger"},[_c('FormLabel',{attrs:{"input-id":"datepicker-trigger","label-text":_vm.label}}),_vm._v(" "),_c('div',{staticClass:"c_box--pos--relative"},[_c('client-only',[_c('input',{attrs:{"type":"text","id":"datepicker-trigger","placeholder":_vm.$t('Select dates')},domProps:{"value":_vm.formatDates(_vm.startDate, _vm.endDate)}}),_vm._v(" "),_c('AirbnbStyleDatepicker',{attrs:{"date-one":_vm.startDate,"date-two":_vm.endDate,"fullscreen-mobile":true,"months-to-show":1,"show-shortcuts-menu-trigger":false,"trigger-element-id":'datepicker-trigger',"aria-labels":{
            chooseDate: (date) => date,
            chooseStartDate: (date) => `${_vm.$t('Choose')} ${date} ${_vm.$t('as your start date.')}`,
            chooseEndDate: (date) => `${_vm.$t('Choose')} ${date} ${_vm.$t('as your end date.')}`,
            selectedDate: (date) => `${_vm.$t('Selected.')} ${date}`,
            unavailableDate: (date) => `${_vm.$t('Not available.')} ${date}`,
            previousMonth: _vm.$t('Move backward to switch to the previous month.'),
            nextMonth: _vm.$t('Move forward to switch to the next month.'),
            closeDatepicker: _vm.$t('Close calendar'),
            openKeyboardShortcutsMenu: _vm.$t('Open keyboard shortcuts menu.'),
            closeKeyboardShortcutsMenu: _vm.$t('Close keyboard shortcuts menu'),
          },"keyboard-shortcuts":[
            { symbol: '↵', label: _vm.$t('Select the date in focus'), symbolDescription: _vm.$t('Enter key') },
            {
              symbol: '←/→',
              label: _vm.$t('Move backward (left) and forward (right) by one day.'),
              symbolDescription: _vm.$t('Left or right arrow keys'),
            },
            {
              symbol: '↑/↓',
              label: _vm.$t('Move backward (up) and forward (down) by one week.'),
              symbolDescription: _vm.$t('Up or down arrow keys'),
            },
            { symbol: 'PgUp/PgDn', label: _vm.$t('Switch months.'), symbolDescription: _vm.$t('PageUp and PageDown keys') },
            {
              symbol: 'Home/End',
              label: _vm.$t('Go to the first or last day of a week.'),
              symbolDescription: _vm.$t('Home or End keys'),
            },
            { symbol: 'Esc', label: _vm.$t('Close this panel'), symbolDescription: _vm.$t('Escape key') },
            { symbol: '?', label: _vm.$t('Open this panel'), symbolDescription: _vm.$t('Question mark') },
          ]},on:{"opened":_vm.onDatePickerOpened,"date-one-selected":(val) => {
              _vm.startDate = _vm.endDate = val;
              _vm.onDatePickerUpdate();
            },"date-two-selected":(val) => {
              _vm.endDate = val;
              _vm.onDatePickerUpdate();
            }}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }